<template>
  <DashboardWidgetLineStack class="widget-redditivita" title="Analisi Redditività" :dataY="dataY" :dataX="dataX" :legendData="['EBITDA', 'Risultato Netto']" />
</template>

<script>

export default {
  name: 'dashboard-widget-redditivita',
  components: {
    DashboardWidgetLineStack: () => import('../BaseWidgets/DashboardWidgetLineStack'),
  },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    dataX () {
      return this.values.map(v => v.date);
    },
    dataY () {
      return [
        {
          symbol: 'circle',
          symbolSize: 8,
          name: 'EBITDA',
          type: 'line',
          color: '#289ad8',
          data: this.values.map(v => v.ebitda),
          lineStyle: {
            color: 'rgba(40, 154, 216,.5)',
          },
          smooth: true,
        },
        {
          symbol: 'circle',
          symbolSize: 8,
          name: 'Risultato Netto',
          type: 'line',
          color: '#ec632b',
          data: this.values.map(v => v.risultatoNetto),
          lineStyle: {
            color: 'rgba(236, 99, 43, .5)',
          },
          smooth: true,
        },
      ];
    },
  },
};

</script>
